import React, { Component } from 'react';
import "../../css/RegistroFirma.css";
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';
import CrearFirmaElectronica from './CrearFirmaElectronica';
import CrearFirmaIcon from '../../assets/CrearfirmaICO.svg';
import "../../css/Modal.css";  // Importamos el archivo CSS del modal
import MenuUsuario from './MenuUsuario';
import jwt from 'jwt-decode'
import Cookies from 'js-cookie';
import { ComponenteSpinner } from '../adminComponents/ComponenteSpinner';
import { ReactComponent as FirmaSubidaIcon } from '../../assets/FirmaSUBIDA(ESPOL).svg';
import SignDocument from "./SignDocument.js";

export default class FirmarDocumentoEspol extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firmas: [],  // Inicializado vacío para que las filas se agreguen dinámicamente
      modalVisible: false,  // Estado para controlar la visibilidad del modal
      canCreateFirma: true,
      msgVisible: false,            // Modal de mensajes (info/error)
      msgTitle: '',
      msgBody: '',
      nombre_completo:'',
      loading:true,
      token: sessionStorage.getItem("access_token"),
    };
  }

  componentDidMount() {
    //this.handleloadfirmas();
    var token = Cookies.get("token");
     if (
        !token ||
        token === "undefined" ||
        token === "null" ||
        token.split(".").length !== 3
    ) {
        console.warn("Cookie token no válida o inexistente");
        return;
    }
    try {
        const tokendecode = jwt(token);
        this.setState({
            nombre_completo:
                `${tokendecode["Nombres"] || ""} ${tokendecode["Apellidos"] || ""}`
        });
    } catch (error) {
        console.error("Error decodificando token:", error);
    }
  }



  render() {
    const { modalVisible, msgVisible, msgTitle, msgBody } = this.state;
    return (
      <div>
        <MenuUsuario
          mostrarNombre={true}
          nombresCompletos={this.state.nombre_completo}
        />

        <Header />
        <div className="registrofirma-container">
          <SignDocument />
        </div>
        <Footer />
      </div>
    );
  }
}

